import { Matrix, Quaternion } from '@babylonjs/core/Maths';
import { Mesh } from '@babylonjs/core/Meshes/mesh';
import { VertexData } from '@babylonjs/core/Meshes/mesh.vertexData';
import { TransformNode } from '@babylonjs/core/Meshes/transformNode';
import { Scene } from '@babylonjs/core/scene';
import { ShadowOnlyMaterial } from '@babylonjs/Materials/shadowOnly/shadowOnlyMaterial';
import { KbViewer } from '@kb3d/view/kb-viewer';
import { Subscription } from 'rxjs';
import { BoundingBoxInfo } from '../bounding-box-cache';

/** padding in size to make enough space for shadow blur */
const SIZE_RATIO = 4;

export class XrShadowPlane extends Mesh {
    constructor(public v: KbViewer, public scene: Scene) {
        super('xrShadowPlane', scene);

        this.receiveShadows = true;
        this.isPickable = false;
        this.shadowMaterial = new ShadowOnlyMaterial('xrShadowMaterial', scene);
        this.shadowMaterial.alpha = 0.4;

        this.material = this.shadowMaterial;
        // this.material = v.rendererManager.material.defaultMaterial;

        this.setEnabled(false);
    }

    private subscription: Subscription = new Subscription();
    private shadowMaterial: ShadowOnlyMaterial;

    public place(rootNode: TransformNode) {
        this.setParent(rootNode);

        const bbCache = this.v.bbCache;
        const bb = bbCache.get(this.v.sceneNode)!;
        if (bb) {
            this.resize(bb);
            this.setEnabled(true);

            this.subscription.add(
                bbCache.rootBoundingBoxChanged.subscribe(newBb => {
                    this.resize(bb);
                })
            );
        }
    }

    protected resize(bb: BoundingBoxInfo) {
        const width = (bb.max.x - bb.min.x) * SIZE_RATIO;
        const height = (bb.max.z - bb.min.z) * SIZE_RATIO;

        const vertexData = VertexData.CreatePlane({
            width,
            height,
            sideOrientation: 0,
        });
        //bake in a 90 degree rotation so it's flat on the ground
        const rotMatrix = new Matrix();
        Quaternion.FromEulerAngles(Math.PI / 2, 0, 0).toRotationMatrix(rotMatrix);
        vertexData.transform(rotMatrix);
        vertexData.applyToMesh(this, true);

        this.position.set(bb.center.x, 0, bb.center.z);
    }

    public dispose() {
        this.subscription.unsubscribe();
        super.dispose();
        if (this.shadowMaterial) this.shadowMaterial.dispose();
    }
}
